@if (risk && risk.id > 0) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property"><b>{{ 'risk.detailMain.summaryId' | transloco }}</b> {{ risk.identifier }}</div>
                <div class="property"><b>{{ 'risk.detailMain.summaryName' | transloco }}</b> {{ risk.name }}</div>
                <div class="property">
                    <b>{{ 'risk.detailMain.summaryRegistrationDate' | transloco }}</b> {{ risk.dateCreated | dateFormat }}
                </div>
            </div>
            <div class="col-6">
                <div class="property"><b>{{ 'risk.detailMain.summaryLastModifier' | transloco }}</b> {{ risk.lastModifier }}</div>
                <div class="property"><b>{{ 'risk.detailMain.summaryRiskOwner' | transloco }}</b> {{ risk.owner }}</div>
                <div class="property"><b>{{ 'risk.detailMain.summaryIsKeyRisk' | transloco }}</b> {{ risk.isKeyRisk ? "Yes" : "No" }}</div>
            </div>
        </div>
    </div>
}

<form [formGroup]="parentForm">
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'risk.detailMain.riskDetailsTitle' | transloco }}</div>
        <div class="detail-page-card-body padded">
            @if (riskInitialized) {
                <div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="form-group">
                                <label for="organizationSelect">{{ 'risk.detailMain.organizationLabel' | transloco }}</label>
                                <cerrix-select-tree
                                    [getDataMethod]="organizationRequest"
                                    formControlName="organizationId"
                                    placeholder="Required"
                                    [multiselect]="false"
                                    data-uiid="organization-tree"
                                >
                                </cerrix-select-tree>
                                @if (enableBudgetBasedRisk) {
                                    <label class="budget-label"
                                        >Budget: {{ currentOrganizationBudget }}</label
                                    >
                                }
                            </div>
                            <div class="form-group">
                                <label for="riskAreaSelect">{{ 'risk.detailMain.riskAreaLabel' | transloco }}</label>
                                <cerrix-select
                                    id="riskAreaSelect"
                                    name="riskAreaSelect"
                                    [getDataMethod]="riskAreaRequest"
                                    prettyName="risk area"
                                    formControlName="riskAreaId"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    dataUiid="risk-area-select"
                                >
                                </cerrix-select>
                            </div>
                            <div class="form-group">
                                <label>
                                    {{ 'risk.detailMain.riskCatalogueLabel' | transloco }}
                                    @if (!selectedOrganizationId || selectedOrganizationId <= 0) {
                                        <i
                                            class="far fa-question-circle ms-2"
                                            [matTooltip]="'risk.detailMain.pleaseSelectOrgFirst' | transloco"
                                        ></i>
                                    }
                                </label>
                                <cerrix-select
                                    [hidden]="!subTypesLoaded && !rootCauseCategoryLoaded"
                                    #riskCatalogueCmp
                                    id="riskCatalogueSelect"
                                    formControlName="riskCatalogueId"
                                    prettyName="risk catalogue"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [getDataMethod]="riskCatalogueRequest"
                                    placeholder="Required"
                                    (valueChange)="riskCatalogueChanged($event, true)"
                                    dataUiid="risk-catalogue-select"
                                >
                                </cerrix-select>
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="form-group">
                                <label>
                                    {{ 'risk.detailMain.businessDimensionsLabel' | transloco }}
                                    @if (!selectedOrganizationId || selectedOrganizationId <= 0) {
                                        <i
                                            class="far fa-question-circle ms-2"
                                            [matTooltip]="'risk.detailMain.pleaseSelectOrgFirst' | transloco"
                                        ></i>
                                    }
                                </label>
                                <cerrix-select-tree
                                    [getDataMethod]="businessDimensionsRequest"
                                    formControlName="businessDimensionIds"
                                    [multiselect]="true"
                                    (onChangeIds)="reloadFrameworkDimensions($event)"
                                    data-uiid="business-dimensions-tree"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="form-group">
                                <cerrix-textarea
                                    [fieldLabel]="'risk.detailMain.definitionRiskCatalogueLabel' | transloco"
                                    identifier="definitionRiskCatalogueInput"
                                    [rows]="9"
                                    formControlName="definitionRiskCatalogue"
                                    dataUiid="definition-risk-catalogue-input"
                                ></cerrix-textarea>
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="form-group">
                                <label>
                                    {{ 'risk.detailMain.frameworkDimensionsLabel' | transloco }}
                                    @if (!selectedOrganizationId || selectedOrganizationId <= 0) {
                                        <i
                                            class="far fa-question-circle ms-2"
                                            [matTooltip]="'risk.detailMain.pleaseSelectOrgFirst' | transloco"
                                        ></i>
                                    }
                                </label>
                                <cerrix-select-tree
                                    [getDataMethod]="frameworkDimensionsRequest"
                                    formControlName="frameworkDimensionIds"
                                    [multiselect]="true"
                                    data-uiid="framework-dimensions-tree"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="form-group">
                                <label for="subTypeSelect">{{ 'risk.detailMain.subtypesLabel' | transloco }}</label>
                                @if (filteredSubTypes.length > 0) {
                                    <ng-select
                                        [multiple]="true"
                                        [closeOnSelect]="false"
                                        id="subTypeSelect"
                                        name="subTypeSelect"
                                        [items]="filteredSubTypes"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        formControlName="subtypeIds"
                                        dataUiid="subtype-select"
                                    ></ng-select>
                                } @else {
                                    <div>{{ 'risk.detailMain.noSubtypesAvailable' | transloco }}</div>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="form-group">
                                <label for="riskOwnerInput">{{ 'risk.detailMain.riskOwnerLabel' | transloco }}</label>
                                <cerrix-select
                                    #ownersCmp
                                    id="riskOwnerSelect"
                                    formControlName="owner"
                                    prettyName="risk owner"
                                    bindLabel="Name"
                                    bindValue="Name"
                                    [addTag]="true"
                                    [getDataMethod]="riskOwnersRequest"
                                    placeholder="Required"
                                    dataUiid="risk-owner-select"
                                >
                                </cerrix-select>
                            </div>
                            <div class="form-group">
                                <label for="riskInformedInput">{{ 'risk.detailMain.riskInformedLabel' | transloco }}</label>
                                <cerrix-select
                                    #informedCmp
                                    id="riskInformedSelect"
                                    formControlName="informedUserIds"
                                    prettyName="risk informed"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [multiple]="true"
                                    [getDataMethod]="riskInformedsRequest"
                                    dataUiid="risk-informed-select"
                                >
                                </cerrix-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="form-group">
                                <cerrix-textfield
                                    [fieldLabel]="'risk.detailMain.riskNameLabel' | transloco"
                                    identifier="riskNameInput"
                                    formControlName="name"
                                    placeholder="Required"
                                    dataUiid="risk-name-input"
                                >
                                </cerrix-textfield>
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="form-group">
                                <label for="eventCategorySelect">{{ 'risk.detailMain.rootCauseCategoryLabel' | transloco }}</label>
                                <cerrix-select-tree
                                    formControlName="rootCauseCategoryIds"
                                    [multiselect]="true"
                                    [getDataMethod]="rootCauseCategoryRequest"
                                    data-uiid="event-category-tree"
                                >
                                </cerrix-select-tree>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="form-group">
                                <ai-description-generator
                                    [fieldLabel]="'risk.detailMain.descriptionLabel' | transloco"
                                    identifier="descriptionInput"
                                    [rows]="
                                        permissions.showCauseField && permissions.showEffectField
                                            ? 10
                                            : 5
                                    "
                                    formControlName="description"
                                    cssClass="form-control"
                                    dataUiid="risk-description-input"
                                    [fetchDescriptionsDatamethod]="fetchDescriptions"
                                    (onDescriptionGenerated)="onDescriptionGenerated($event)"
                                ></ai-description-generator>
                            </div>
                        </div>

                        <div class="col-12 col-xl-6 right-block">
                            @if (permissions.showCauseField) {
                                <div class="form-group">
                                    <cerrix-textarea
                                        [fieldLabel]="'risk.detailMain.causesLabel' | transloco"
                                        identifier="causesInput"
                                        [rows]="9"
                                        formControlName="cause"
                                        dataUiid="risk-cause-input"
                                    ></cerrix-textarea>
                                </div>
                            }

                            @if (permissions.showEffectField) {
                                <div class="form-group">
                                    <cerrix-textarea
                                        [fieldLabel]="'risk.detailMain.effectsLabel' | transloco"
                                        identifier="effectsInput"
                                        [rows]="9"
                                        formControlName="effect"
                                        dataUiid="risk-effect-input"
                                    ></cerrix-textarea>
                                </div>
                            }
                        </div>
                    </div>

                    <hr />
                    <div class="bottom-bar">
                        <cerrix-checkbox
                            formControlName="applicable"
                            [label]="'risk.detailMain.applicableLabel' | transloco"
                            fontsize="0.9em"
                            data-uiid="risk-applicable-checkbox"
                        >
                        </cerrix-checkbox>
                        <cerrix-checkbox
                            formControlName="isKeyRisk"
                            [label]="'risk.detailMain.isKeyRiskLabel' | transloco"
                            fontsize="0.9em"
                            data-uiid="risk-key-risk-checkbox"
                        >
                        </cerrix-checkbox>
                        <cerrix-checkbox
                            formControlName="confidential"
                            [label]="'risk.detailMain.confidentialLabel' | transloco"
                            fontsize="0.9em"
                            data-uiid="risk-confidential-checkbox"
                        >
                        </cerrix-checkbox>
                        <cerrix-checkbox
                            formControlName="approved"
                            [label]="'risk.detailMain.approvedLabel' | transloco"
                            fontsize="0.9em"
                            data-uiid="risk-approved-checkbox"
                        >
                        </cerrix-checkbox>
                        <cerrix-checkbox
                            formControlName="reviewed"
                            [label]="'risk.detailMain.reviewedLabel' | transloco"
                            fontsize="0.9em"
                            data-uiid="risk-reviewed-checkbox"
                        >
                        </cerrix-checkbox>
                    </div>
                </div>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>

    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'risk.detailMain.riskScoringTitle' | transloco }}</div>
        <div class="detail-page-card-body padded cerrix-control-sm">
            @if (riskInitialized) {
                <div>
                    <div class="row">
                        <div class="col" [class.left-block]="!enableTargetRisk">
                            <div style="max-width: 400px; margin: 0 auto">
                                <cerrix-riskmatrix
                                    #riskmatrix
                                    [OrganizationID]="risk.organizationId"
                                    [readonly]="permissions.readonly"
                                    [cellSize]="50"
                                    [cellSpacing]="1"
                                    [(selected)]="grossRiskMatrix"
                                    (selectedChange)="grossRiskMatrixChanged($event)"
                                >
                                </cerrix-riskmatrix>
                            </div>

                            <div class="form-group">
                                <label for="grossLikelihoodSelect">{{ 'risk.detailMain.grossLikelihoodLabel' | transloco }}</label>
                                <cerrix-select
                                    id="grossLikelihoodSelect"
                                    name="grossLikelihoodSelect"
                                    formControlName="likelihoodId"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    placeholder="Required"
                                    [getDataMethod]="likelihoodRequest"
                                    prettyName="likelihood"
                                    dataUiid="gross-likelihood-select"
                                >
                                </cerrix-select>
                            </div>

                            <div class="form-group">
                                <label for="grossImpactSelect">{{ 'risk.detailMain.grossImpactLabel' | transloco }}</label>
                                <cerrix-select
                                    id="grossImpactSelect"
                                    name="grossImpactSelect"
                                    formControlName="impactId"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    placeholder="Required"
                                    [getDataMethod]="impactRequest"
                                    prettyName="impact"
                                    (valueChange)="checkCustomScaleValuesAreAlignable()"
                                    dataUiid="gross-impact-select"
                                >
                                </cerrix-select>
                                @if (alignCustomGrossIndex != null) {
                                    <small
                                        class="scale-align-text"
                                        (click)="setGrossImpactToCustomScale()"
                                        >Gross impact is different than
                                        {{ alignCustomLeadingValue ? "leading" : "highest" }} custom
                                        impact, click here to align.</small
                                    >
                                }
                            </div>

                            @if (enableBudgetBasedRisk) {
                                <div class="form-group">
                                    <label for="grossFinancialImpact"
                                        >{{ 'risk.detailMain.grossFinancialImpactLabel' | transloco }}</label
                                    >
                                    <input
                                        type="number"
                                        data-uiid="gross-financial-impact-input"
                                        class="form-control form-control-sm"
                                        name="grossFinancialImpact"
                                        formControlName="financialImpactGross"
                                    />
                                </div>
                            }
                        </div>

                        <div class="col" [class.right-block]="!enableTargetRisk">
                            <div style="max-width: 400px; margin: 0 auto">
                                <cerrix-riskmatrix
                                    #riskmatrix
                                    [OrganizationID]="risk.organizationId"
                                    [readonly]="permissions.readonly"
                                    [cellSize]="50"
                                    [cellSpacing]="1"
                                    [(selected)]="netRiskMatrix"
                                    (selectedChange)="netRiskMatrixChanged($event)"
                                >
                                </cerrix-riskmatrix>
                            </div>

                            <div class="form-group">
                                <label for="netLikelihoodSelect">{{ 'risk.detailMain.netLikelihoodLabel' | transloco }}</label>
                                <cerrix-select
                                    id="netLikelihoodSelect"
                                    name="netLikelihoodSelect"
                                    formControlName="netLikelihoodId"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [closeOnSelect]="true"
                                    [getDataMethod]="likelihoodRequest"
                                    prettyName="likelihood"
                                    dataUiid="net-likelihood-select"
                                >
                                </cerrix-select>
                            </div>

                            <div class="form-group">
                                <label for="netImpactSelect">{{ 'risk.detailMain.netImpactLabel' | transloco }}</label>
                                <cerrix-select
                                    id="netImpactSelect"
                                    name="netImpactSelect"
                                    formControlName="netImpactId"
                                    bindLabel="Name"
                                    bindValue="ID"
                                    [getDataMethod]="impactRequest"
                                    prettyName="impact"
                                    (valueChange)="checkCustomScaleValuesAreAlignable()"
                                    dataUiid="net-impact-select"
                                >
                                </cerrix-select>
                                @if (alignCustomNetIndex !== null) {
                                    <small
                                        class="scale-align-text"
                                        (click)="setNetImpactToCustomScale()"
                                        >Net impact is different than
                                        {{ alignCustomLeadingValue ? "leading" : "highest" }} custom
                                        impact, click here to align.</small
                                    >
                                }
                            </div>

                            @if (enableBudgetBasedRisk) {
                                <div class="form-group">
                                    <label for="netFinancialImpact"
                                        >{{ 'risk.detailMain.netFinancialImpactLabel' | transloco }}</label
                                    >
                                    <input
                                        type="number"
                                        data-uiid="net-financial-impact-input"
                                        class="form-control form-control-sm"
                                        name="netFinancialImpact"
                                        formControlName="financialImpactNet"
                                    />
                                </div>
                            }
                        </div>

                        @if (enableTargetRisk) {
                            <div class="col">
                                <div style="max-width: 400px; margin: 0 auto">
                                    <cerrix-riskmatrix
                                        #riskmatrix
                                        [OrganizationID]="risk.organizationId"
                                        [readonly]="permissions.readonly"
                                        [cellSize]="50"
                                        [cellSpacing]="1"
                                        [(selected)]="targetRiskMatrix"
                                        (selectedChange)="targetRiskMatrixChanged($event)"
                                    >
                                    </cerrix-riskmatrix>
                                </div>

                                <div class="form-group">
                                    <label for="targetLikelihoodSelect">{{ 'risk.detailMain.targetLikelihoodLabel' | transloco }}</label>
                                    <cerrix-select
                                        id="targetLikelihoodSelect"
                                        name="targetLikelihoodSelect"
                                        formControlName="targetLikelihoodId"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="true"
                                        [getDataMethod]="likelihoodRequest"
                                        prettyName="likelihood"
                                        dataUiid="target-likelihood-select"
                                    >
                                    </cerrix-select>
                                </div>

                                <div class="form-group">
                                    <label for="targetImpactSelect"
                                        >{{ 'risk.detailMain.targetImpactLabel' | transloco }}</label
                                    >
                                    <cerrix-select
                                        id="targetImpactSelect"
                                        name="targetImpactSelect"
                                        formControlName="targetImpactId"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [getDataMethod]="impactRequest"
                                        prettyName="impact"
                                        (valueChange)="checkCustomScaleValuesAreAlignable()"
                                        dataUiid="target-impact-select"
                                    >
                                    </cerrix-select>
                                    @if (alignCustomTargetIndex !== null) {
                                        <small
                                            class="scale-align-text"
                                            (click)="setTargetImpactToCustomScale()"
                                            >Target impact is different than
                                            {{ alignCustomLeadingValue ? "leading" : "highest" }}
                                            custom impact, click here to align.</small
                                        >
                                    }
                                </div>

                                @if (enableBudgetBasedRisk) {
                                    <div class="form-group">
                                        <label for="targetFinancialImpact"
                                            >{{ 'risk.detailMain.targetFinancialImpactLabel' | transloco }}</label
                                        >
                                        <input
                                            type="number"
                                            data-uiid="target-financial-impact-input"
                                            class="form-control form-control-sm"
                                            name="targetFinancialImpact"
                                            formControlName="financialImpactTarget"
                                        />
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <!-- Check if you have any custom impact scales, otherwise do not load this section -->
                    @if (showCustomImpactScales) {
                        <div class="form-group-separator"></div>

                        @if (impactScaleData && parentForm && risk) {
                            <div>
                                <risk-impact-scales
                                    [parentForm]="parentForm"
                                    [(risk)]="risk"
                                    [impactScaleData]="impactScaleData"
                                    [enableTargetRisk]="enableTargetRisk"
                                    [enableBudgetBasedRisk]="enableBudgetBasedRisk"
                                    (onValueChange)="checkCustomScaleValuesAreAlignable()"
                                >
                                </risk-impact-scales>
                            </div>
                        }
                    }

                    @if (enableBudgetBasedRisk) {
                        <div class="row">
                            <div class="form-group-separator"></div>
                            <div class="potential-loss-header mb-2">
                                <label>{{ 'risk.detailMain.potentialLossRangeLabel' | transloco }}</label>
                            </div>
                            <div class="col" [class.left-block]="!enableTargetRisk">
                                <div class="form-group">
                                    <label for="potentialLossGrossMin">{{ 'risk.detailMain.grossMinLabel' | transloco }}</label>
                                    <input
                                        type="number"
                                        data-uiid="risk-potential-loss-gross-min-input"
                                        class="form-control form-control-sm"
                                        name="potentialLossGrossMin"
                                        formControlName="potentialLossGrossMin"
                                        readonly="true"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="potentialLossGrossMax">{{ 'risk.detailMain.grossMaxLabel' | transloco }}</label>
                                    <input
                                        type="number"
                                        data-uiid="risk-potential-loss-gross-max-input"
                                        class="form-control form-control-sm"
                                        name="potentialLossGrossMax"
                                        formControlName="potentialLossGrossMax"
                                        readonly="true"
                                    />
                                </div>
                            </div>

                            <div class="col" [class.right-block]="!enableTargetRisk">
                                <div class="form-group">
                                    <label for="potentialLossNetMin">{{ 'risk.detailMain.netMinLabel' | transloco }}</label>
                                    <input
                                        type="number"
                                        data-uiid="risk-potential-loss-net-min-input"
                                        class="form-control form-control-sm"
                                        name="potentialLossNetMin"
                                        formControlName="potentialLossNetMin"
                                        readonly="true"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="potentialLossNetMax">{{ 'risk.detailMain.netMaxLabel' | transloco }}</label>
                                    <input
                                        type="number"
                                        data-uiid="risk-potential-loss-net-max-input"
                                        class="form-control form-control-sm"
                                        name="potentialLossNetMax"
                                        formControlName="potentialLossNetMax"
                                        readonly="true"
                                    />
                                </div>
                            </div>

                            @if (enableTargetRisk) {
                                <div class="col">
                                    <div class="form-group">
                                        <label for="potentialLossTargetMin">{{ 'risk.detailMain.targetMinLabel' | transloco }}</label>
                                        <input
                                            type="number"
                                            data-uiid="risk-potential-loss-target-min-input"
                                            class="form-control form-control-sm"
                                            name="potentialLossTargetMin"
                                            formControlName="potentialLossTargetMin"
                                            readonly="true"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="potentialLossTargetMax">{{ 'risk.detailMain.targetMaxLabel' | transloco }}</label>
                                        <input
                                            type="number"
                                            data-uiid="risk-potential-loss-target-max-input"
                                            class="form-control form-control-sm"
                                            name="potentialLossTargetMax"
                                            formControlName="potentialLossTargetMax"
                                            readonly="true"
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>

    @if (showQuantitativeScoring) {
        <risk-quantitative-scoring
            [parentForm]="parentForm"
            [likelihoodRequest]="likelihoodRequest"
            [impactRequest]="impactRequest"
            [grossImpactActive]="grossRiskMatrix.Impact"
            [grossLikelihoodActive]="grossRiskMatrix.Likelihood"
            [netImpactActive]="netRiskMatrix.Impact"
            [netLikelihoodActive]="netRiskMatrix.Likelihood"
        ></risk-quantitative-scoring>
    }

    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'risk.detailMain.riskAssessmentTitle' | transloco }}</div>
        <div class="detail-page-card-body padded cerrix-control-sm">
            @if (riskInitialized) {
                <div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="row">
                                <div class="form-group col">
                                    <label for="riskAppetite">
                                        Risk appetite assessment (Based on '{{
                                            risk.riskCatalogue.Name
                                        }}')
                                    </label>
                                    <input
                                        class="form-control form-control-sm"
                                        id="riskAppetite"
                                        name="riskAppetite"
                                        [class.appetiteNotSet]="
                                            riskAppetiteInLine == RiskAppetiteType.NotSet
                                        "
                                        [class.appetiteInLine]="
                                            riskAppetiteInLine == RiskAppetiteType.InLine
                                        "
                                        [class.appetiteNotInLine]="
                                            riskAppetiteInLine == RiskAppetiteType.NotInLine
                                        "
                                        [value]="riskAppetiteInfo"
                                        disabled
                                        inputTooltip
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <label for="riskTreatmentSelect">{{ 'risk.detailMain.riskTreatmentLabel' | transloco }}</label>
                                    <cerrix-select
                                        id="riskTreatmentSelect"
                                        name="riskTreatmentSelect"
                                        formControlName="riskTreatmentId"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [getDataMethod]="riskTreatmentRequest"
                                        prettyName="risk treatment"
                                        dataUiid="risk-treatment-select"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="row">
                                <div class="form-group col">
                                    <label for="riskAssessmentSelect"
                                        >{{ 'risk.detailMain.overallRiskAssessmentLabel' | transloco }}</label
                                    >
                                    <cerrix-select
                                        id="riskAssessmentSelect"
                                        name="riskAssessmentSelect"
                                        formControlName="riskAssessmentId"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [getDataMethod]="overallAssessmentRequest"
                                        prettyName="overall risk assessment"
                                        dataUiid="overall-risk-assessment-select"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col">
                                    <label for="riskAssessmentDate">{{ 'risk.detailMain.assessmentDateLabel' | transloco }}</label>
                                    <date-input
                                        id="riskAssessmentDate"
                                        formControlName="riskAssessmentDate"
                                        data-uiid="assessment-date-input"
                                    ></date-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="row">
                                <div
                                    [hidden]="riskAppetiteInLine != RiskAppetiteType.NotInLine"
                                    class="form-group col"
                                >
                                    <cerrix-textarea
                                        [fieldLabel]="'risk.detailMain.commentOnRiskAppetiteLabel' | transloco"
                                        identifier="riskAppetiteCommentInput"
                                        [rows]="9"
                                        formControlName="appetiteComment"
                                        dataUiid="risk-appetite-input"
                                    ></cerrix-textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="row">
                                <div class="form-group col">
                                    <cerrix-textarea
                                        [fieldLabel]="'risk.detailMain.commentOnOverallRiskAssessmentLabel' | transloco"
                                        identifier="riskAssessmentCommentInput"
                                        [rows]="9"
                                        formControlName="riskAssessmentComment"
                                        data-uiid="risk-assessment-comment-input"
                                    ></cerrix-textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>

    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'risk.detailMain.commentsCustomFieldsTitle' | transloco }}</div>
        <div class="detail-page-card-body padded cerrix-control-sm">
            @if (riskInitialized) {
                <div>
                    <div class="row">
                        <div class="col-12 form-group">
                            <cerrix-textarea
                                [fieldLabel]="'risk.detailMain.commentsLabel' | transloco"
                                identifier="commentsInput"
                                [rows]="9"
                                formControlName="comments"
                                data-uiid="risk-comments-input"
                            ></cerrix-textarea>
                        </div>
                    </div>
                    <div class="row">
                        <cerrix-custom-fields-editor
                            [singleColumn]="false"
                            [parentForm]="parentForm"
                            [customFieldData]="customFieldData"
                        >
                        </cerrix-custom-fields-editor>
                    </div>
                </div>
            } @else {
                <div class="fancy-loader submodule"></div>
            }
        </div>
    </div>
</form>
